import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appNumbersOnly]',
})
export class NumbersOnlyDirective {
  regexStr = '^[0-9]+$';
  constructor(private _el: ElementRef) {}
  @HostListener('keypress', ['$event'])
  onKeyPress(event) {
    if (
      event.key === '-' &&
      event.target.selectionStart === 0 &&
      event.target.value.charAt(0) !== '-'
    ) {
      return true;
    } else if (event.key === '.' && !event.target.value.includes('.')) {
      return true;
    } else {
      return new RegExp(this.regexStr).test(event.key);
    }
  }

  @HostListener('paste', ['$event'])
  blockPaste(event: any) {
    this.validateFields(event);
  }

  // type is ClipboardEvent but angular universal is crashing at runtime
  validateFields(event: any) {
    event.preventDefault();
    const pasteData = event.clipboardData
      .getData('text/plain')
      .replace(/[^0-9]/g, '');
    document.execCommand('insertHTML', false, pasteData);
  }
}
